<template lang="html">

  <section class="wrapper home">

    <div class="encabezado" data="home"></div>

    <div class="content">

      <div class="claim-home">
        <h2>Programa Clave</h2>
        <p>ULE a través de Programa Clave pone en contacto Empresas y perfiles profesionales.</p>
      </div>


      <section class="ofertas-wrapper container row-between ais">
        <ofertas></ofertas>
        <accesos></accesos>
      </section>


      <section class="accesos-big">
        <div class="container row-between">
          <article class="acceso-big" data="faqs">
            <h2>Preguntas frecuentes</h2>
            <router-link :to="$t('enlaces.faqs')" class="enlace-cover"></router-link>
          </article>
          <article class="acceso-big" data="contacto">
            <h2>Contacta con nosotros</h2>
            <router-link :to="$t('enlaces.contacto')" class="enlace-cover"></router-link>
          </article>
        </div>
      </section>


    </div>


  </section>

</template>

<script lang="js">

  import comunicaciones from '@/components/view-parts/home/comunicaciones';
  import ofertas from '@/components/view-parts/home/ofertas';

  import programasactivos from '@/components/view-parts/home/programas-activos';

  import accesos from '@/components/parts/accesos';

  export default {
    name: 'home',
    components: {
      'comunicaciones': comunicaciones,
      'programasactivos': programasactivos,
      'ofertas': ofertas,
      'accesos': accesos
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/home.vue